<div class="bg-logo"></div>
<section class="page">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</section>
